// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as JsxRuntime from "react/jsx-runtime";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CommonCardFieldHooks$OrcaPaymentPage from "./CommonCardFieldHooks.bs.js";

function SecureCardExpiryField(props) {
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let state = CommonCardFieldHooks$OrcaPaymentPage.useCardExpiryField(loggerState, true, undefined);
  return JsxRuntime.jsx(CommonCardFieldHooks$OrcaPaymentPage.RenderCardExpiry.make, {
    state: state
  });
}

let make = SecureCardExpiryField;

export {
  make,
}
/* jotai Not a pure module */
